import Slider from "react-slick";
import { useGetBannerQuery } from "../../../../redux/services/internal/apiHome";
import Loader from "../../Components/Loader";

const HomeBanner = ({ benchId }) => {
  //slider settings
  console.log(benchId)
  const settings = {
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  const {
    data: banners,
    isLoading,
    isError,
  } = useGetBannerQuery(benchId, {
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }



  return (
    <>
      <Slider {...settings}>
        {banners.data ? (
          banners.data.map((banner, index) => (
            <div className="banner-area" key={index}>
              <img
                src={banner.image_url}
                alt={banner.image_url}
                className="w-100"
              />
            </div>
          ))
        ) : (
          <div>{isError}</div>
        )}
      </Slider>
    </>
  );
};

export default HomeBanner;
